const Minimize = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 34.2 34.2"
  >
    <path
      id="resize_13451521"
      d="M29.755.854H6.153a5.3,5.3,0,0,0-5.3,5.3v23.6a5.3,5.3,0,0,0,5.3,5.3h23.6a5.3,5.3,0,0,0,5.3-5.3V6.153a5.3,5.3,0,0,0-5.3-5.3ZM17.684,17.52l-.01.012a.577.577,0,0,1-.062.076h0a.592.592,0,0,1-.09.074l-.014.008a.582.582,0,0,1-.308.09h0l-5.559-.007a.584.584,0,0,1,0-1.169h0l4.147.005L9.336,10.157a.585.585,0,0,1,.827-.827l6.449,6.45v-.821l0-3.327a.584.584,0,0,1,.584-.585h0a.585.585,0,0,1,.584.584l0,2,0,3.552a.583.583,0,0,1-.1.333Zm8.889,9.058a.585.585,0,0,1-.827,0L19.3,20.123l0,4.149a.585.585,0,0,1-.584.585h0a.585.585,0,0,1-.584-.584l-.006-5.561a.583.583,0,0,1,.092-.314l.005-.01a.592.592,0,0,1,.074-.09h0c.012-.012.026-.021.039-.032a.526.526,0,0,1,.383-.138l5.553.008a.584.584,0,0,1,0,1.169h0L20.126,19.3l6.447,6.453A.584.584,0,0,1,26.572,26.578Z"
      transform="translate(-0.854 -0.854)"
      fill="inherit"
    />
  </svg>
);

export default Minimize;
